import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  card: {
    fontSize: "8",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    height: "60vh",
    padding: "5%",
    borderRadius: 10,
    color: "white",
  },
  container: {
    padding: "0 3%",
    width: "100%",
    margin: 0,
  },
});
